<template>
  <div class="flexEvent">
    <div class="flexAuto">
      <ECard title="管理员设置">
        <div class="firstName"><span>姓名</span><span>{{ infrom.name }}</span></div>
        <div class="firstName"><span>身份证号</span><span>{{ infrom.idNo }}</span></div>
        <div class="firstName"><span>手机号</span><span>{{ infrom.mobile }}</span></div>
      </ECard>
    </div>
  </div>
</template>

<script>
import ECard from '@/view/common/ECard.vue';
export default {
  name: 'Operator',
  components: {
    ECard: ECard
  },
  data () {
    return {
      infrom: {}
    }
  },
  mounted () {
    this.upDataInfrom();
  },
  methods: {
    upDataInfrom () {
      this.$get(`/company/manager`).then((res) => {
        console.log(res)
        this.infrom = res.data;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.flexEvent{
  width: 100%;
  padding: 20px;
  .flexAuto{
    .firstName{
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      span:first-child{
        width: 100px;
        display: block;
        color: #333333;
      }
      span:nth-child(2){
        color: #333333;
      }
    }
  }
}
</style>
